import { create } from 'zustand';
import { FeedbackService } from '../services/payloadService';

interface TestStore {
    activePlan: any | null;
    tickets: any[];
    isLoading: boolean;
    isWidgetOpen: boolean;

    fetchActivePlan: () => Promise<void>;
    fetchMyTickets: (userId: string) => Promise<void>;
    createTicket: (data: any) => Promise<void>;
    toggleWidget: () => void;
    setWidgetOpen: (isOpen: boolean) => void;
}

export const useTestStore = create<TestStore>((set, get) => ({
    activePlan: null,
    tickets: [],
    isLoading: false,
    isWidgetOpen: false,

    fetchActivePlan: async () => {
        set({ isLoading: true });
        try {
            const result = await FeedbackService.getTestPlans();
            // Assume result.docs contains the plans
            if (result.docs && result.docs.length > 0) {
                set({ activePlan: result.docs[0] });
            }
        } catch (error) {
            console.error('Failed to fetch test plan', error);
        } finally {
            set({ isLoading: false });
        }
    },

    fetchMyTickets: async (userId: string) => {
        // Implementation pending user ID availability
        try {
            const result = await FeedbackService.getMyTickets(userId);
            if (result.docs) {
                set({ tickets: result.docs });
            }
        } catch (error) {
            console.error(error);
        }
    },

    createTicket: async (data: any) => {
        set({ isLoading: true });
        try {
            await FeedbackService.createTicket(data);
            // Refresh tickets?
            const state = get();
            // Mock refresh or re-fetch if we had userId
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            set({ isLoading: false });
        }
    },

    toggleWidget: () => set((state) => ({ isWidgetOpen: !state.isWidgetOpen })),
    setWidgetOpen: (isOpen) => set({ isWidgetOpen: isOpen }),
}));
